import regionApi from '~/clientApis/regionApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';

export const deleteRegions = async (ids: string[]): Promise<void> => {
    try {
        await regionApi.deleteRegions(ids);
    } catch {
        showMessageModal('error', 'Failed to delete regions');
    }
};
